<template>
  <div class="match-new">
    <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom shadow-sm mb-3">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="back-icon bi bi-arrow-left-short" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
          </svg>
          <span>{{$t('general.newmatch')}}</span>
        </router-link>
      </div>
    </nav>
    <div class="container">      
      <section class="pt-4 pb-3 text-center container">
        <div class="row py-lg-5">
          <div class="col-lg-6 col-md-8 mx-auto">
            <h1 class="font-weight-light">{{$t('general.newmatch')}}</h1>
            <p class="lead text-muted">
              {{$t('newmatch.description')}}
            </p>            
          </div>
        </div>        
      </section>  
       <p class="mt-2 text-center">
        <a class="btn btn-primary mt-2 mb-3 px-3 py-3 mr-2" v-on:click="newMatch()">{{$t('newmatch.fromscratch')}}</a><br/>
        <a class="btn btn-dark my-2 py-3 px-3" v-on:click="goToSpond()">{{$t('newmatch.fromspond')}}</a>
      </p>          
    </div>    
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import moment from "moment";
import { set, get, keys, Store } from "idb-keyval";
import { Guid } from "guid-typescript";
import { Match } from "../models/Models";
import axios from 'axios';
import router from '../router';

export default class MatchNew extends Vue {
  
  async goToSpond() {    
    const spondStore = new Store('playmatch-db', 'spond-store');    
    const token = await get('spondToken', spondStore)
    if (token) {
      router.push({ name: "SpondMatches" });
    } else {
      router.push({ name: "SpondLogin" });
    }
  }

  async newMatch() {
    const match: Match = {
      id: Guid.create().toString(),
      homeCount: 0,
      opponent: undefined,
      awayCount: 0,
      isRunning: false,
      hasStarted: false,
      totalSecondsPlayed: 0,
      homeGame: undefined,
      matchPlayedTime: "",
      lastStarted: undefined,
      players: [],
      created: moment().format('YYYY-MM-DD HH:mm:ss')
    };

    await set(match.id, match);

    router.push({ name: "MatchDetails", params: { id: match.id } });
  }
}
</script>
